(function () {
    'use strict';

    angular.module('app')
        .factory('Autor', Autor);

    /* @ngInject */
    function Autor($resource) {
        return $resource('api/admin/autor/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/autor/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/autor/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/autor/findAll'
            }
        });
    }
})();
